import { Column } from '../Column';
import { styled } from '../../theme';
import type { NumberedStepVariant } from './Step';

type WrapperProps = {
	variant?: NumberedStepVariant;
};

export const Wrapper = styled(Column)<WrapperProps>`
	gap: ${({ theme, variant }) =>
		variant === 'card' ? `${theme.space.xs}px` : `${theme.space.sm}px`};
`;
